import { render, staticRenderFns } from "./ModalContentAddContractorContact.vue?vue&type=template&id=8b2e4f10&"
import script from "./ModalContentAddContractorContact.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddContractorContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddContractorContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports